import { render, staticRenderFns } from "./LayoutLogin.vue?vue&type=template&id=2bc7c31c&scoped=true"
import script from "./LayoutLogin.vue?vue&type=script&lang=js"
export * from "./LayoutLogin.vue?vue&type=script&lang=js"
import style0 from "./LayoutLogin.vue?vue&type=style&index=0&id=2bc7c31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7c31c",
  null
  
)

export default component.exports